export const imageURL = process.env.REACT_APP_IMAGE_URL + "/hongbo";
